export default __webpack_public_path__ + "static/media/Snd3.793b5db0.mp3";